import { render, staticRenderFns } from "./stepAttachmentFiles.vue?vue&type=template&id=20d72afc&scoped=true&"
import script from "./stepAttachmentFiles.vue?vue&type=script&lang=js&"
export * from "./stepAttachmentFiles.vue?vue&type=script&lang=js&"
import style0 from "./stepAttachmentFiles.vue?vue&type=style&index=0&id=20d72afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d72afc",
  null
  
)

export default component.exports